import React, { useState } from 'react';
import { PortalProvider } from 'react-portal-hook';
import { MutableSnapshot, RecoilRoot } from 'recoil';
import { OffersList } from './components/offer-listing';
import { OfferHeader } from './components/offer-header';
import { OfferListing } from '~/common/models';
import { ActiveSpecialOffers } from './store';
import styles from './index.module.scss';

interface SpecialOffersProps {
  mainTitle?: string;
  secondaryTitle?: string;
  specialOffers: OfferListing[];
}

export const SpecialOffers = (props: SpecialOffersProps) => {
  const initialize = ({ set }: MutableSnapshot) => {
    set(ActiveSpecialOffers, props.specialOffers);
  };
  const [headerLoaded, setHeaderLoaded] = useState(false);

  return (
    <RecoilRoot initializeState={initialize}>
      <PortalProvider>
        <div className={styles.offersContainer}>
          <div
            className={styles.offersHeaderTitle}
            dangerouslySetInnerHTML={{ __html: props.mainTitle as string }}
          />
          <OfferHeader onLoaded={() => setHeaderLoaded(true)} />

          {headerLoaded && <OffersList secondaryTitle={props.secondaryTitle} />}
        </div>
      </PortalProvider>
    </RecoilRoot>
  );
};
